import {
  FETCH_WAREHOUSE_LIST_DONE,
  FETCH_WAREHOUSE_LIST_LOADING,
  FETCH_WAREHOUSE_LIST_ERROR,
  POST_WAREHOUSE_DRAFT_DONE,
  POST_WAREHOUSE_DRAFT_LOADING,
  POST_WAREHOUSE_DRAFT_ERROR,
  POST_WAREHOUSE_SUBMIT_DONE,
  POST_WAREHOUSE_SUBMIT_LOADING,
  POST_WAREHOUSE_SUBMIT_ERROR,
  FETCH_INBOUND_LIST_DONE,
  FETCH_INBOUND_LIST_LOADING,
  FETCH_INBOUND_LIST_ERROR,
  FETCH_SKU_DETAIL_DONE,
  FETCH_SKU_DETAIL_LOADING,
  FETCH_SKU_DETAIL_ERROR,
  CANCEL_INBOUND_DONE,
  CANCEL_INBOUND_LOADING,
  CANCEL_INBOUND_ERROR,
  EDIT_SKU_DONE,
  EDIT_SKU_LOADING,
  EDIT_SKU_ERROR,
  INBOUND_DOCUMENT_DONE,
  INBOUND_DOCUMENT_LOADING,
  INBOUND_DOCUMENT_ERROR,
  INBOUND_HISTORY_DONE,
  INBOUND_HISTORY_LOADING,
  INBOUND_HISTORY_ERROR,
  FETCH_INVENTORY_LIST_DONE,
  FETCH_INVENTORY_LIST_LOADING,
  FETCH_INVENTORY_LIST_ERROR,
  FETCH_INVENTORY_DETAIL_DONE,
  FETCH_INVENTORY_DETAIL_LOADING,
  FETCH_INVENTORY_DETAIL_ERROR,
  INVENTORY_HISTORY_DONE,
  INVENTORY_HISTORY_LOADING,
  INVENTORY_HISTORY_ERROR,
  DOWNLOAD_SKU_DONE,
  DOWNLOAD_SKU_LOADING,
  DOWNLOAD_SKU_ERROR,
  DOWNLOAD_FILE_INVENTORY_DONE,
  DOWNLOAD_FILE_INVENTORY_LOADING,
  DOWNLOAD_FILE_INVENTORY_ERROR,
  MOVE_INVENTORY_DONE,
  MOVE_INVENTORY_LOADING,
  MOVE_INVENTORY_ERROR,
  MULTIPLE_SKU_UPLOAD_DONE,
  MULTIPLE_SKU_UPLOAD_LOADING,
  MULTIPLE_SKU_UPLOAD_ERROR,
  DOWNLOAD_OUT_STORAGE_REPORT_DONE,
  DOWNLOAD_OUT_STORAGE_REPORT_LOADING,
  DOWNLOAD_OUT_STORAGE_REPORT_ERROR
} from './actions'

export default {
  [FETCH_WAREHOUSE_LIST_LOADING](state) {
    state.isLoadingWarehouseList = true
  },
  [FETCH_WAREHOUSE_LIST_DONE](state, items) {
    state.warehouseList = items
    state.isLoadingWarehouseList = false
  },
  [FETCH_WAREHOUSE_LIST_ERROR](state, error) {
    state.errorWarehouseList = error
    state.isLoadingWarehouseList = false
  },

  [POST_WAREHOUSE_DRAFT_LOADING](state) {
    state.isLoadingPostDraft = true
  },
  [POST_WAREHOUSE_DRAFT_DONE](state, items) {
    state.postDraft = items
    state.errorPostDraft = false
    state.isLoadingPostDraft = false
  },
  [POST_WAREHOUSE_DRAFT_ERROR](state, error) {
    state.errorPostDraft = error
    state.isLoadingPostDraft = false
  },

  [POST_WAREHOUSE_SUBMIT_LOADING](state) {
    state.isLoadingPostSubmit = true
  },
  [POST_WAREHOUSE_SUBMIT_DONE](state, items) {
    state.postSubmit = items
    state.errorPostSubmit = false
    state.isLoadingPostSubmit = false
  },
  [POST_WAREHOUSE_SUBMIT_ERROR](state, error) {
    state.errorPostSubmit = error
    state.isLoadingPostSubmit = false
  },

  [FETCH_INBOUND_LIST_LOADING](state) {
    state.isLoadingInboundList = true
  },
  [FETCH_INBOUND_LIST_DONE](state, items) {
    state.inboundList = items
    state.isLoadingInboundList = false
  },
  [FETCH_INBOUND_LIST_ERROR](state, error) {
    state.errorInboundList = error
    state.isLoadingInboundList = false
  },

  [FETCH_SKU_DETAIL_LOADING](state) {
    state.isLoadingInboundDetail = true
  },
  [FETCH_SKU_DETAIL_DONE](state, items) {
    state.inboundDetail = items
    state.isLoadingInboundDetail = false
  },
  [FETCH_SKU_DETAIL_ERROR](state, error) {
    state.errorInboundDetail = error
    state.isLoadingInboundDetail = false
  },

  [CANCEL_INBOUND_LOADING](state) {
    state.isLoadingCancelInbound = true
  },
  [CANCEL_INBOUND_DONE](state, items) {
    state.cancelInbound = items
    state.isLoadingCancelInbound = false
  },
  [CANCEL_INBOUND_ERROR](state, error) {
    state.errorCancelInbound = error
    state.isLoadingCancelInbound = false
  },

  [EDIT_SKU_LOADING](state) {
    state.isLoadingEditSKU = true
  },
  [EDIT_SKU_DONE](state, items) {
    state.editSKU = items
    state.isLoadingEditSKU = false
  },
  [EDIT_SKU_ERROR](state, error) {
    state.errorEditSKU = error
    state.isLoadingEditSKU = false
  },

  [INBOUND_DOCUMENT_LOADING](state) {
    state.isLoadingInboundDocument = true
  },
  [INBOUND_DOCUMENT_DONE](state, items) {
    state.inboundDocument = items
    state.isLoadingInboundDocument = false
  },
  [INBOUND_DOCUMENT_ERROR](state, error) {
    state.errorInboundDocument = error
    state.isLoadingInboundDocument = false
  },

  [INBOUND_HISTORY_LOADING](state) {
    state.isLoadingInboundHistory = true
  },
  [INBOUND_HISTORY_DONE](state, items) {
    state.inboundHistory = items
    state.isLoadingInboundHistory = false
  },
  [INBOUND_HISTORY_ERROR](state, error) {
    state.errorInboundHistory = error
    state.isLoadingInboundHistory = false
  },

  [FETCH_INVENTORY_LIST_LOADING](state) {
    state.isLoadingInventoryList = true
  },
  [FETCH_INVENTORY_LIST_DONE](state, items) {
    state.inventoryList = items
    state.isLoadingInventoryList = false
  },
  [FETCH_INVENTORY_LIST_ERROR](state, error) {
    state.errorInventoryList = error
    state.isLoadingInventoryList = false
  },

  [FETCH_INVENTORY_DETAIL_LOADING](state) {
    state.isLoadingInventoryDetail = true
  },
  [FETCH_INVENTORY_DETAIL_DONE](state, items) {
    state.inventoryDetail = items
    state.isLoadingInventoryDetail = false
  },
  [FETCH_INVENTORY_DETAIL_ERROR](state, error) {
    state.errorInventoryDetail = error
    state.isLoadingInventoryDetail = false
  },

  [INVENTORY_HISTORY_LOADING](state) {
    state.isLoadingInventoryHistory = true
  },
  [INVENTORY_HISTORY_DONE](state, items) {
    state.inventoryHistory = items
    state.isLoadingInventoryHistory = false
  },
  [INVENTORY_HISTORY_ERROR](state, error) {
    state.errorInventoryHistory = error
    state.isLoadingInventoryHistory = false
  },

  [DOWNLOAD_SKU_LOADING](state) {
    state.isLoadingDownloadSku = true
  },
  [DOWNLOAD_SKU_DONE](state, items) {
    state.downloadSku = items
    state.isLoadingDownloadSku = false
  },
  [DOWNLOAD_SKU_ERROR](state, error) {
    state.errorDownloadSku = error
    state.isLoadingDownloadSku = false
  },

  [MOVE_INVENTORY_LOADING](state) {
    state.isLoadingMoveInventory = true
  },
  [MOVE_INVENTORY_DONE](state, items) {
    state.moveinventory = items
    state.isLoadingMoveInventory = false
  },
  [MOVE_INVENTORY_ERROR](state, error) {
    state.errorMoveInventory = error
    state.isLoadingMoveInventory = false
  },

  [DOWNLOAD_FILE_INVENTORY_LOADING](state) {
    state.isLoadingDownloadFileInventory = true
  },
  [DOWNLOAD_FILE_INVENTORY_DONE](state, items) {
    state.downloadFileInventory = items
    state.isLoadingDownloadFileInventory = false
  },
  [DOWNLOAD_FILE_INVENTORY_ERROR](state, error) {
    state.errorDownloadFileInventory = error
    state.isLoadingDownloadFileInventory = false
  },

  [MULTIPLE_SKU_UPLOAD_LOADING](state) {
    state.isLoadingMultipleSkuUpload = true
  },
  [MULTIPLE_SKU_UPLOAD_DONE](state, items) {
    state.multipleSkuUpload = items
    state.errorMultipleSkuUpload = false
    state.isLoadingMultipleSkuUpload = false
  },
  [MULTIPLE_SKU_UPLOAD_ERROR](state, error) {
    state.errorMultipleSkuUpload = error
    state.isLoadingMultipleSkuUpload = false
  },

  [DOWNLOAD_OUT_STORAGE_REPORT_LOADING](state) {
    state.isLoadingDownloadOutStorageReport = true
  },
  [DOWNLOAD_OUT_STORAGE_REPORT_DONE](state, items) {
    state.downloadOutStorageReport = items
    state.isLoadingDownloadOutStorageReport = false
  },
  [DOWNLOAD_OUT_STORAGE_REPORT_ERROR](state, error) {
    state.errorDownloadOutStorageReport = error
    state.isLoadingDownloadOutStorageReport = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/warehouse/mutations.js